export default {
  talk_to_us: 'Soita meille:',
  send_us_email: 'Lähetä meille sähköpostia:',
  visit_website: 'Vieraile verkkosivullamme:',
  join_our_community: 'Liity yhteisöömme ja saat eksklusiivisia tarjouksia ja uutisia!',
};
